import { render, staticRenderFns } from "./RecycleManage.vue?vue&type=template&id=1f829613&scoped=true"
import script from "./RecycleManage.vue?vue&type=script&lang=js"
export * from "./RecycleManage.vue?vue&type=script&lang=js"
import style0 from "./RecycleManage.vue?vue&type=style&index=0&id=1f829613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f829613",
  null
  
)

export default component.exports